import React, { useState, useEffect } from "react";
import { Container, Tab, Nav } from "react-bootstrap";
import { Form } from "react-bootstrap";
import NoData from "../../common/NoData";
import Alerts from "../../common/Alerts";
import KeycafeService from "../../../services/KeycafeService";
import PropertyService from "../../../services/PropertyService";
import SettingsSidebar from "../../common/SettingsSidebar";
import { ScrollingCarousel } from "@trendyol-js/react-carousel";
import Instructions from "../keycafe/Instructions";

const OtherLockMapping = (props) => {
  const [units, setUnits] = useState([]);
  const [isSubmit, setSubmit] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertModalType, setAlertModalType] = useState("");
  const [alertModalTitle, setAlertModalTitle] = useState("");
  const [alertModalMessage, setAlertModalMessage] = useState("");
  const [activeClass, setActiveClass] = useState("alerts");
  const [lockType, setLockType] = useState(false);

  useEffect(() => {
    getUnitData();
    getLockType();
  }, []);
  function getActiveClass(e) {
    setActiveClass(e);
  }
  function changeHandler(event, index) {
    let value = event.target.value;
    let mapData = [...units];
    mapData[index].key_id = value;
    setUnits(mapData);
  }
  const getUnitData = async () => {
    var list = [];
    let res = await KeycafeService.getUnitData(
      "property_slug=" + props.match.params.propertySlug
    );

    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data : {};
    }
    setUnits(list);
  };

  const getLockType = async () => {
    let lockType = 0;
    let res = await PropertyService.getProperty(
      props.match.params.propertySlug
    );
    if (
      global.successStatus.includes(res.status) &&
      res.data &&
      res.data.lock_type
    ) {
      lockType = res.data.lock_type;
    }
    setLockType(lockType);
  };

  const saveOrUpdateUnits = async (event) => {
    event.preventDefault();
    setSubmit(true);
    let res = [];
    let inputData = {
      property_slug: props.match.params.propertySlug,
      units: units,
    };

    res = await KeycafeService.mappingUnits(inputData);
    if (global.successStatus.includes(res.status)) {
      setSubmit(false);
      setShowAlertModal(true);
      setAlertModalType("success");
      setAlertModalTitle("Success");
      setAlertModalMessage(res.message ? res.message : "Success");
    } else {
      setSubmit(false);
      setShowAlertModal(true);
      setAlertModalType("error");
      setAlertModalTitle(res.data.errorCode ? res.data.errorCode : "Error!");
      setAlertModalMessage(res.data.message ? res.data.message : "Error");
    }
    setTimeout(() => setShowAlertModal(false), global.alert_close_time);
    getUnitData();
  };

  return (
    <main>
      <Container className="innter-container">
        <div className="d-flex flex-column">
          <div className="row row-xs mg-t-0 pd-t-0">
            <div className="col-md-2 left">
              <div className="child-menu-section">
                <aside>
                  <SettingsSidebar
                    property_slug={props.match.params.propertySlug}
                  />
                </aside>
              </div>
            </div>
            <div className="col-md-10 right">
              <div className="col-md-12 mg-t-20 mg-b-10"></div>
              <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0 keycafe-header-sticky-">
                <div className="dashbaord-pageHeadertitle dashboardRightcard d-flex justify-content-between align-items-center flex-wrap mg-b-0 swipersectionBtns keycafemappingtitle">
                  <h3>Other Mapping </h3>
                </div>
              </div>
              {lockType === 10 ? (
                <div className="scrolling-carousel pd-l-15">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="alerts"
                    onSelect={(e) => getActiveClass(e)}
                    eventKey={activeClass}
                  >
                    <ScrollingCarousel
                      rightArrow={true}
                      leftArrow={true}
                      className="swipesection scroll_nav_mob"
                    >
                      <Nav.Item>
                        <Nav.Link
                          eventKey="alerts"
                          id="infoForm"
                          className={activeClass === "alerts" ? "active" : ""}
                        >
                          Unit Mapping
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="alert-activity"
                          id="alert-activity"
                          className={
                            activeClass === "alert-activity" ? "active" : ""
                          }
                        >
                          Pick Up/Drop Off Instructions
                        </Nav.Link>
                      </Nav.Item>
                    </ScrollingCarousel>
                    <Tab.Content className="pd-lg-l-15 pd-lg-r-15 pd-xs-l-15 pd-xs-r-0 mg-t-15">
                      <Tab.Pane eventKey="alerts">
                        <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30 swipersectionBtns">
                          <div className="d-flex flex-wrap justify-content-end bothBtn align-items-center swiperBtns">
                            {global.userPermissions.checkPermission(
                              "other-lock-add"
                            ) && (
                              <button
                                className="btn-success-outline-small ml-3 button-width"
                                type="button"
                                disabled={isSubmit ? true : false}
                                onClick={saveOrUpdateUnits}
                              >
                                {isSubmit ? global.loader : "Save"}
                              </button>
                            )}
                          </div>

                          <div className="row align-items-center border-bottom-0 mapp_head_desk m-0">
                            <div className="col-md-11 pd-xs-l-0 pd-xs-r-0">
                              <div className="row w-100">
                                <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-l-15 pd-lg-r-30 pd-xs-r-0 ">
                                  <label className="form-label text-left mg-b-0">
                                    Unit
                                  </label>
                                </div>
                                <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-l-12 pd-lg-r-30 pd-xs-r-0 ">
                                  <label className="form-label text-left mg-b-0">
                                    Key ID
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row align-items-center border-bottom-0">
                            <div className="col-md-12 pd-lg-r-30 pd-lg-l-30 pd-xs-l-15 pd-xs-r-15 mg-t-15">
                              <Alerts
                                show={showAlertModal}
                                type={alertModalType}
                                title={alertModalTitle}
                                message={alertModalMessage}
                              />
                            </div>
                            {units.length > 0 ? (
                              units.map((item, index) => {
                                return (
                                  <>
                                    <div className="row w-100 m-0">
                                      <div className="col-md-11 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
                                        <div className="row w-100">
                                          <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-l-15 pd-lg-r-30 pd-xs-r-0 mg-b-15">
                                            <label className="form-label text-left mg-b-0 mapp_head_mob">
                                              Unit
                                            </label>
                                            <Form.Control
                                              name="unit_number"
                                              value={
                                                item.unit_name
                                                  ? item.unit_name
                                                  : item.unit_number
                                              }
                                              disabled={true}
                                              className="form-control max_width_100"
                                              type="text"
                                            />
                                          </div>
                                          <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-l-15 pd-lg-r-30 pd-xs-r-0 mg-b-15">
                                            <label className="form-label text-left mg-b-0 mapp_head_mob">
                                              Key ID
                                            </label>
                                            <Form.Control
                                              onChange={(e) =>
                                                changeHandler(e, index)
                                              }
                                              name="serial_number"
                                              value={item.key_id}
                                              className="form-control max_width_100"
                                              type="text"
                                              disabled={false}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })
                            ) : (
                              <NoData msg="Other" />
                            )}
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="alert-activity">
                        <Instructions
                          propertySlug={props.match.params.propertySlug}
                          lockType={lockType}
                        />
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              ) : lockType === 1 ? (
                <div className="col-md-12 mg-t-0 mg-b-10 pd-t-15 pd-b-10 pd-lg-l-45 pd-xs-l-15 pd-r-0">
                  <p className="pets_no_text text-left font-italic">
                    This property is using Key Cafe.
                  </p>
                </div>
              ) : lockType === 2 ? (
                <div className="col-md-12 mg-t-0 mg-b-10 pd-t-15 pd-b-10 pd-lg-l-45 pd-xs-l-15 pd-r-0">
                  <p className="pets_no_text text-left font-italic">
                    This property is using Latch.
                  </p>
                </div>
              ) : lockType === 3 ? (
                <div className="col-md-12 mg-t-0 mg-b-10 pd-t-15 pd-b-10 pd-lg-l-45 pd-xs-l-15 pd-r-0">
                  <p className="pets_no_text text-left font-italic">
                    This property is using Igloo.
                  </p>
                </div>
              ) : lockType === 10 ? (
                <div className="col-md-12 mg-t-0 mg-b-10 pd-t-15 pd-b-10 pd-lg-l-45 pd-xs-l-15 pd-r-0">
                  <p className="pets_no_text text-left font-italic">
                    This property is using Other.
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </Container>
    </main>
  );
};

export default OtherLockMapping;
